<script lang="ts">
  import cn from 'classnames';

  import { Font, FontTypes } from '@uikit/font';

  import { BaseCountdown } from './components/base-countdown';

  import s from './countdown.module.css';

  export let finishMs: number;
  export let className: string | undefined = undefined;
  export let onDone: (() => void) | undefined = undefined;

</script>

<BaseCountdown from={finishMs} {onDone} let:remaining>
    {#if remaining.done === false}
        <div class={cn(s.timer, className)}>
            <Font
                type={FontTypes.Type.h4}
                tagName={FontTypes.TagName.span}
                color={FontTypes.Color.Primary}
                isBold={true}
            >
                {Math.floor(remaining.minutes / 10)}
            </Font>
            <Font
                type={FontTypes.Type.h4}
                tagName={FontTypes.TagName.span}
                color={FontTypes.Color.Primary}
                isBold={true}
            >
                {remaining.minutes % 10}
            </Font>
            :
            <Font
                type={FontTypes.Type.h4}
                tagName={FontTypes.TagName.span}
                color={FontTypes.Color.Primary}
                isBold={true}
            >
                {Math.floor(remaining.seconds / 10)}
            </Font>
            <Font
                type={FontTypes.Type.h4}
                tagName={FontTypes.TagName.span}
                color={FontTypes.Color.Primary}
                isBold={true}
            >
                {remaining.seconds % 10}
            </Font>
        </div>
    {/if}
</BaseCountdown>